import { apiB2B, apiB2C, apiBase, apiBaseWithBlob } from '../axios-client';
import { OMS_ORDER_DETAILS_PATH, PRINT_RETURN_SHIPPING_LABEL_PATH, RETURN_SORIS_CANCEL_PATH, OMS_ORDER_DETAILS_LOCAL_DELIVERY_PATH, OMS_PTC_DOCUMENTS_PATH, } from '../../constants/paths';
import { getXClientApp } from '../../utils/channel-helpers';
// B2B Order Details Calls
export var GetOrderDetailsAPI = function (customerType, customerRole, requestData, channel, localDelivery) {
    // Always send channel headers since we can't predict if backend will use CPS or LSS
    var headers = {
        channel: channel,
        'X-Client-App': getXClientApp(channel),
    };
    var requestConfig = { headers: headers };
    if (customerType === 'b2b' ||
        (customerType === 'b2x' && customerRole !== '')) {
        if (localDelivery) {
            return apiB2B.post(OMS_ORDER_DETAILS_LOCAL_DELIVERY_PATH, requestData, requestConfig);
        }
        return apiB2B.post(OMS_ORDER_DETAILS_PATH, requestData, requestConfig);
    }
    return apiB2C.post(OMS_ORDER_DETAILS_PATH, requestData, requestConfig);
};
export var GetSelectedOrderDetailsAPI = function (requestData, channel) {
    return apiBase.post(OMS_ORDER_DETAILS_PATH, requestData, {
        headers: {
            channel: channel,
            'X-Client-App': getXClientApp(channel),
        },
    });
};
// Returns Calls
export var ReturnShippingLabelAPI = function (requestData, xAuthGuestToken) {
    var headers = {};
    if (xAuthGuestToken) {
        headers['X-Auth-GuestToken'] = xAuthGuestToken;
    }
    return apiB2B.post(PRINT_RETURN_SHIPPING_LABEL_PATH, requestData, {
        headers: headers,
    });
};
export var GetSORISCancelAPI = function (requestData) {
    return apiB2B.post(RETURN_SORIS_CANCEL_PATH, requestData);
};
// Export Order Details Page Information
export var ExportOrderDetails = function (requestData) {
    return apiBaseWithBlob.post("".concat(OMS_ORDER_DETAILS_PATH, "/export"), requestData);
};
/**
 * Bectran API calls
 */
export var GetBectranDocumentsAPI = function (request) {
    return apiBase.post(OMS_PTC_DOCUMENTS_PATH, request);
};
export var GetSelectedBectranDocumentAPI = function (request) {
    return apiBaseWithBlob.post("".concat(OMS_PTC_DOCUMENTS_PATH, "/").concat(request.invoiceFileRequest.invoiceType), request);
};
